var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailWidgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#2A9D8F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "#9097A5",
    strokeOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6562 27.25H11.875L11.8728 16.4012L20.091 22.0908C20.2112 22.174 20.3539 22.2185 20.5 22.2185C20.6461 22.2185 20.7888 22.174 20.909 22.0908L29.125 16.4041V22.9375H30.5625V15.75C30.5619 15.3689 30.4103 15.0036 30.1408 14.7342C29.8714 14.4647 29.5061 14.3131 29.125 14.3125H11.875C11.4939 14.3129 11.1285 14.4645 10.859 14.734C10.5895 15.0035 10.4379 15.3689 10.4375 15.75V27.25C10.4381 27.6311 10.5897 27.9964 10.8592 28.2658C11.1286 28.5353 11.4939 28.6869 11.875 28.6875H22.6562V27.25ZM27.543 15.75L20.5 20.626L13.457 15.75H27.543Z",
    fill: "#2A9D8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6875 30.125C29.2753 30.125 30.5625 28.8378 30.5625 27.25C30.5625 25.6622 29.2753 24.375 27.6875 24.375C26.0997 24.375 24.8125 25.6622 24.8125 27.25C24.8125 28.8378 26.0997 30.125 27.6875 30.125Z",
    fill: "#2A9D8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWidgetIcon);
export default __webpack_public_path__ + "static/media/email-widget-icon.562def231fdde4ab3704d679713c2e20.svg";
export { ForwardRef as ReactComponent };